'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSlidedown = require('react-slidedown');

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _AmazonStaffLetters = require('./AmazonStaffLetters.css');

var _AmazonStaffLetters2 = _interopRequireDefault(_AmazonStaffLetters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonStaffLetters = (_dec = (0, _reactCssModules2.default)(_AmazonStaffLetters2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AmazonStaffLetters, _Component);

  function AmazonStaffLetters(props) {
    (0, _classCallCheck3.default)(this, AmazonStaffLetters);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AmazonStaffLetters.__proto__ || (0, _getPrototypeOf2.default)(AmazonStaffLetters)).call(this, props));

    var letterTo = 'winters@amazon.com';
    var letterSubject = 'Amazon 401(k) sustainability';
    var letterText = '\nDear Mr. Winter,\n\nI am an employee of Amazon.com, and I participate in our company retirement plan. I recently found out that the Amazon.com 401(k) has significant investments in fossil fuels, deforestation, arms manufacturers, and companies that score poorly on gender equality. I care about these issues and do not want my retirement savings to support companies that are destroying the environment and fueling social inequality.\n\nThe data on the Amazon.com 401(k) can be found here:\nhttps://investyourvalues.org/retirement-plans/amazon-com\n\nI am also concerned about the financial risks associated with investing my retirement savings in unsustainable industries. Sustainable investing is not just an ethical issue - it is a key factor impacting financial well-being. Department of Labor guidelines state that \u201Cenvironmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment\u201D and can be used when making decisions related to fiduciary duty. Now that I know what I am invested in through our plan, I no longer want to jeopardize my financial security by investing in these risky industries.\n\nCritically, the default plan option, the Vanguard Target Retirement Fund series, is not invested sustainably. Over 50% of assets invested in the Amazon employee retirement plan are invested in these default option target date funds. Because these funds are not invested sustainably, hundreds of millions of dollars in employee savings are being allocated to fossil fuel companies, deforestation-risk commodity producer/traders, and other sustainability risk sectors.\n\nI am proud of the steps we have taken as a company to protect the environment, but we need to have more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon. Please let me know how we can ensure that our company retirement plan is no longer complicit in the destruction of our environment.\n\nI would like to have investment options that support an economy that is based on justice and sustainability. Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you soon.\n\nBest,\n    ';

    var emailHref = 'mailto:' + letterTo + '?subject=' + encodeURIComponent(letterSubject) + '&body=' + encodeURIComponent(letterText);

    _this.state = {
      showAdminLetter: false,
      emailHref: emailHref
    };
    return _this;
  }

  (0, _createClass3.default)(AmazonStaffLetters, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showAdminLetter = _state.showAdminLetter,
          emailHref = _state.emailHref;
      //

      return _react2.default.createElement(
        'div',
        { styleName: 'letter-box' },
        _react2.default.createElement(
          'div',
          { styleName: 'letter-box-flex' },
          _react2.default.createElement(
            'div',
            { styleName: 'letter-box-label' },
            _react2.default.createElement(
              'h2',
              null,
              'Send a message to your 401(k) plan administrator'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Send a message to your 401(k) plan administrator asking them for a sustainable 401(k).'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'button',
                {
                  styleName: 'show-letter-button',
                  onClick: function onClick() {
                    _this2.setState({ showAdminLetter: !showAdminLetter });
                  }
                },
                'Letter to plan admin',
                _react2.default.createElement(_.LinkIcon, {
                  faclass: showAdminLetter ? 'fa-angle-double-up' : 'fa-angle-double-down'
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'take-action-icons' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _.Link,
                {
                  to: emailHref,
                  title: 'Send a message to your 401(k) plan administrator',
                  log: _analytics2.default.eventStaffSupport('Amazon', 'admin_message'),
                  targetBlank: true
                },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'Email'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-envelope' })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          showAdminLetter ? _react2.default.createElement(
            'div',
            { styleName: 'company-letter-slidedown' },
            _react2.default.createElement(
              'p',
              null,
              'Your retirement plan administrator has a legal responsibility to act solely in your interest as a plan participant. Most 401(k) investors are primarily concerned with generating positive returns, but ',
              _react2.default.createElement(
                _.Link,
                {
                  to: _config2.default.routes.eduCenterFinRisks,
                  title: 'Financial risks of unsustainable investments',
                  xstrong: true
                },
                'unsustainable investments could be increasing your financial risk,'
              ),
              ' while also destroying the environment and fueling social inequality. If these are issues that you care about, then your plan administrator has a responsibility to make sure you have the option to invest sustainably. Below is a sample letter you can send to your 401(k) Plan Administrator at Amazon.com, Steve Winter (winters@amazon.com).'
            ),
            _react2.default.createElement(
              'blockquote',
              { styleName: 'company-letter-blockquote' },
              _react2.default.createElement(
                'p',
                null,
                'Dear Mr. Winter,'
              ),
              _react2.default.createElement(
                'p',
                null,
                'I am an employee of Amazon.com, and I participate in our company retirement plan. I recently found out that the Amazon.com 401(k) has significant investments in fossil fuels, deforestation, arms manufacturers, and companies that score poorly on gender equality. I care about these issues and do not want my retirement savings to support companies that are destroying the environment and fueling social inequality.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The data on the Amazon.com 401(k) can be found here:',
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  _.Link,
                  {
                    to: _config2.default.routes.plans + '/amazon-com',
                    title: 'Amazon.com retirement plan sustainability scorecard',
                    xstrong: true
                  },
                  'https://investyourvalues.org/retirement-plans/amazon-com'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'I am also concerned about the financial risks associated with investing my retirement savings in unsustainable industries. Sustainable investing is not just an ethical issue - it is a key factor impacting financial well-being.  Department of Labor guidelines state that \u201Cenvironmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment\u201D and can be used when making decisions related to fiduciary duty. Now that I know what I am invested in through our plan, I no longer want to jeopardize my financial security by investing in these risky industries. '
              ),
              _react2.default.createElement(
                'p',
                null,
                'Critically, the default plan option, the Vanguard Target Retirement Fund series, is not invested sustainably. Over 50% of assets invested in the Amazon employee retirement plan are invested in these default option target date funds. Because these funds are not invested sustainably, hundreds of millions of dollars in employee savings are being allocated to fossil fuel companies, deforestation-risk commodity producer/traders, and other sustainability risk sectors.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'I am proud of the steps we have taken as a company to protect the environment, but we need to have more sustainable and climate-friendly investment options if we want to continue to make a collective difference at Amazon. Please let me know how we can ensure that our company retirement plan is no longer complicit in the destruction of our environment. '
              ),
              _react2.default.createElement(
                'p',
                null,
                'I would like to have investment options that support an economy that is based on justice and sustainability. Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you soon.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Best,',
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'b',
                  null,
                  '[Your Name]',
                  _react2.default.createElement('br', null),
                  '[Your contact information: company department, email, phone, etc.]'
                )
              )
            )
          ) : null
        )
      );
    }
  }]);
  return AmazonStaffLetters;
}(_react.Component)) || _class);
exports.default = AmazonStaffLetters;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonStaffLetters/AmazonStaffAdminLetter.js
// module id = 1367
// module chunks = 0